<router-outlet></router-outlet>
@if (brandService.view === 'fru' && !removeTrackers) {
  <script-tag src="https://www.googletagmanager.com/gtag/js?id=AW-1040949609"></script-tag>
}
@if (brandService.view === 'mm' && !removeTrackers) {
  <script-tag src="https://www.googletagmanager.com/gtag/js?id=AW-996288623"></script-tag>
}
@if (!removeTrackers) {
  <script-tag src="/assets/scripts/form-landing-tracking.js"></script-tag>
}
@if (brandService.trackingSrc && !removeTrackers) {
  <script-tag src="{{brandService.trackingSrc}}"></script-tag>
}
